'use strict';
import * as $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError from "./app.data.-Email-Link-Sign-In-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_EmailLinkSignInError$Other(err) {
  this.Y2 = null;
  this.Y2 = err;
}
export { $c_Lapp_data_EmailLinkSignInError$Other as $c_Lapp_data_EmailLinkSignInError$Other };
$p = $c_Lapp_data_EmailLinkSignInError$Other.prototype = new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError.$h_Lapp_data_EmailLinkSignInError();
$p.constructor = $c_Lapp_data_EmailLinkSignInError$Other;
/** @constructor */
function $h_Lapp_data_EmailLinkSignInError$Other() {
}
export { $h_Lapp_data_EmailLinkSignInError$Other as $h_Lapp_data_EmailLinkSignInError$Other };
$h_Lapp_data_EmailLinkSignInError$Other.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_EmailLinkSignInError$Other) && (this.Y2 === x$0.Y2)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Other";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y2;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 4;
});
function $isArrayOf_Lapp_data_EmailLinkSignInError$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jt)));
}
export { $isArrayOf_Lapp_data_EmailLinkSignInError$Other as $isArrayOf_Lapp_data_EmailLinkSignInError$Other };
var $d_Lapp_data_EmailLinkSignInError$Other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_EmailLinkSignInError$Other, "app.data.EmailLinkSignInError$Other", ({
  jt: 1,
  fR: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_EmailLinkSignInError$Other as $d_Lapp_data_EmailLinkSignInError$Other };
//# sourceMappingURL=app.data.-Email-Link-Sign-In-Error$-Other.js.map
